const faqItems = [
  {
    q: '日皮视频上的蜜桃视频和红桃视频内容是否需要付费？',
    a: '日皮视频平台上的蜜桃视频与红桃视频独家推荐内容面向所有注册用户免费开放。香蕉视频与樱花视频的VIP会员频道内容也已实现免费观看，无需额外付费即可享受高清流畅的观影体验。部分独家策划专题可能会有轻微限制，但核心推荐内容均可随时观看。',
  },
  {
    q: '排行榜是如何计算的？更新频率是怎样的？',
    a: '热播排行榜基于多维数据综合计算，包括观看热度、用户收藏量、观看完成率以及互动活跃度等指标加权得出。排行榜每日自动更新一次，每周进行一次全站综合排名调整，确保榜单始终反映最新最热的内容趋势，帮助你快速发现优质视频。',
  },
  {
    q: '播放卡顿怎么办？支持哪些清晰度？',
    a: '日皮视频全线采用智能CDN加速与自适应码率技术，可根据你的网络状况自动匹配最合适的清晰度，支持480P至1080P高清画质。如果遇到卡顿情况，建议尝试切换网络环境或刷新页面。平台持续优化服务器性能，确保大多数用户都能获得高清流畅不缓冲的体验。',
  },
  {
    q: '如何找到我感兴趣的内容？有没有个性化推荐？',
    a: '你可以通过首页的热门话题标签、排行榜、精选推荐卡片以及专题索引快速发现感兴趣的内容。目前平台正在构建智能推荐引擎，未来将基于你的观看历史与偏好为你推送更精准的个性化内容。当前可以通过各频道分类和搜索功能来浏览全站资源。',
  },
];

export default function FAQSection() {
  return (
    <section id="faq" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-100 font-heading mb-3">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 max-w-[480px] mx-auto">
            关于日皮视频平台的常见疑问解答，助你快速上手
          </p>
        </div>
        <div className="max-w-[800px] mx-auto space-y-4">
          {faqItems.map((item) => (
            <details
              key={item.q}
              className="group rounded-xl bg-background-100 border border-background-200/60 overflow-hidden cursor-pointer"
            >
              <summary className="flex items-center justify-between p-5 md:p-6 list-none">
                <h3 className="text-sm md:text-base font-semibold text-foreground-100 pr-4 font-heading">
                  {item.q}
                </h3>
                <span className="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-full bg-background-200/70 text-foreground-400 group-open:rotate-45 transition-transform duration-200">
                  <i className="ri-add-line text-sm"></i>
                </span>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-500 leading-relaxed">
                  {item.a}
                </p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}